import { useQuery } from "@tanstack/react-query";
import { getExchangeRate } from "../services/get-exchange-rate";

// rate to convert `from` → `to`; null while loading or on error (caller falls
// back to no conversion).
export function useExchangeRate(from?: string, to?: string) {
  return useQuery({
    queryKey: ["exchange-rate", from, to],
    queryFn: () => getExchangeRate(from as string, to as string),
    enabled: !!from && !!to,
    staleTime: 1000 * 60 * 60, // rates change slowly; cache an hour
    retry: 1,
  });
}
